export default __webpack_public_path__ + "static/media/news.bb500b7f.svg";